'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import PasswordChange from "./components/PasswordChange.vue";

var _class = function _class() {
    _classCallCheck(this, _class);

    Vue.component('password-change', PasswordChange);
};

export default _class;


//////////////////
// WEBPACK FOOTER
// ./resources/templates/semperit/assets/js/modules/password-change/index.js
// module id = null
// module chunks = 